var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('auth-logon-form',{attrs:{"loading":_vm.isLoading,"error-response":_vm.errorResponse},on:{"submit":_vm.onSubmit}}),_c('auth-helper',{attrs:{"text":"Есть аккаунт?","to":{ name: 'auth.login' },"link-text":"Войти"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }